import React from 'react';
import { Provider, useDispatch } from 'react-redux';
import store, { persistor } from './redux/store';
import { MainRoutes } from './navigation/config/Routes';
import ToastMessage from './components/atoms/toast_message';
import { PersistGate } from 'redux-persist/integration/react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Colors } from './styles';
import reactLogger from 'utils/logger';
import Dialog from 'components/compounds/dialog';
import { ModalIDs } from './redux/reducers/gl_modal_reducer/types';
import ModalActions from './redux/reducers/gl_modal_reducer/actions';
import AuthActions from './redux/reducers/gl_auth_reducer/actions';
import { useHistory } from 'react-router';

// Or Create your Own theme:
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: Colors.APP_COLOR_SECONDARY(),
    },
    primary: {
      main: Colors.APP_COLOR_PRIMARY(),
    },
  },
});

const App: React.FC = () => {
  reactLogger.renderPage('App');

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MuiThemeProvider theme={theme}>
          <MainRoutes />
          <ToastMessage />
          <SessionExpiredDialog />
        </MuiThemeProvider>
      </PersistGate>
    </Provider>
  );
};

const SessionExpiredDialog = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <Dialog
      MODAL_ID={ModalIDs.MODAL_SESSION_EXPIRED}
      title={'Session Expired'}
      body={
        'Your session has been expired. You will be automatically redirected to Login Page. Please login back in.'
      }
      actions={[
        {
          label: 'OK',
          onClick: () => {
            dispatch(
              ModalActions.closeModalAction({
                modalID: ModalIDs.MODAL_SESSION_EXPIRED,
              })
            );
            dispatch(AuthActions.logoutAction(history));
          },
        },
      ]}
    />
  );
};

export default App;
